// import React from "react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Slider from "react-slick";
// import { useGSAP } from "@gsap/react";
// import gsap from 'gsap'
// import Lenis from 'lenis'
// import { ScrollTrigger } from 'gsap/all';
// import SplitType from 'split-type'

import AnimatedText from "../component/animation";
// import FadeInOnScroll from "../component/scrollanimation";


import ContactForm from '../component/form-contact';
import Header from "../component/header";
import Footer from "../component/footer"; 

// Video 
// import video from '../assets/videos/6000805_Craft_Crafting Beer_3840x2160.mp4'
import howwework from '../assets/images/Homepage/Contact-us.webp'
// Image
import background from '../assets/images/green-black.webp'
import career01 from '../assets/images/career/Life-at-Arkane-1.webp'
import career02 from '../assets/images/career/Life-at-Arkane-2.webp'
import career03 from '../assets/images/career/Life-at-Arkane-3.webp'
// import career02 from '../assets/images/Home/Ourteam/Our-Core-Team.webp'



function Careers({ jobTitles }) {
    const [jobs, setJobs] = useState([]);

useEffect(() => {
  fetch("https://arkane.in/apijob/read.php")
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) {
        setJobs(data);
      } else {
        setJobs([]); // force array
        console.error("API error:", data);
      }
    })
    .catch(err => {
      console.error(err);
      setJobs([]);
    });
}, []);



     var settings = {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 5000,
      };


const [fileName, setFileName] = useState("No file selected");

 const handleFileChange = (e) => {
  if (e.target.files.length > 0) {
    const file = e.target.files[0];
    setFileName(file.name);

    setForm(prev => ({
      ...prev,
      resume: file  
    }));
  } else {
    setFileName("No file selected");
    setForm(prev => ({
      ...prev,
      resume: null
    }));
  }
};

      const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    jobTitle: "",
    resume: null
  });

const handleChange = (e) => {
  const { name, value } = e.target;
  setForm(prev => ({
    ...prev,
    [name]: value
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    Object.keys(form).forEach(key => {
      data.append(key, form[key]);
    });

    try {
      const res = await fetch("https://arkane.in/apijob/apply.php", {
        method: "POST",
        body: data
      });

      const result = await res.json();

      if (result.success) {
        toast.success("Application submitted successfully!");
        setOpen(false);
        setForm({
          name: "",
          email: "",
          phone: "",
          jobTitle: "",
          resume: null
        });
      } else {
        toast.error(result.message || "Mail sending failed");
      }
    } catch (error) {
      toast.error("Server error. Please try again later.");
    } finally {
      setLoading(false);
      setOpen(false)
    }
  };


    return (
        <section>
            <Header/>
            <main>
               
                <div className="section location-banner">
                  <img alt="" className="backgrouns-img" src={background}/>
                    <div className="base-container w-container">
                        <h1>Build Your Future With Us</h1>
                        <p className="_w-69 align-center">At Arkane Engineering, we believe great companies are built by great people. Our strength lies not only in the quality of our stainless-steel equipment but in the passion, integrity, and skill of the team behind it. We’re on an exciting growth journey—expanding our footprint across India and into the European market—and we’re looking for dedicated individuals who want to grow with us.</p>
                    </div>
                </div>


        
                
                <div className="section  without-top-spacing object-container section-scroll-animation ">
                        <div className="base-container w-container">

                            <div className="w-layout-grid best-content-wrapper">
                                <div className="img-content">
                                  <h2><AnimatedText text="Who We Look For" animationType="scale"  /></h2>
                                    <div className="img-container px-600">
                                            <img src={howwework} alt="Bottle of beer" className="bottle-beer" />
                                    </div>
                                </div>

                                <div className="best-content-wrap animate-section-trigger">
                                      
                                    <div className="best-content">
                                        <div>
                                            <h2 className="primary-text"><AnimatedText text="Passion" animationType="scale"  /></h2>
                                            <p className="_w-69">
                                                <AnimatedText text="Individuals who care about doing things the right way—precision, discipline, and attention to detail." animationType="fade-up" />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="best-content center-block">
                                        <div>
                                            <h2 className="primary-text"><AnimatedText text="Integrity" animationType="scale" /></h2>
                                            <p className="_w-69">
                                                <AnimatedText text="Honest, responsible professionals who uphold our values and take pride in their work." animationType="fade-up" />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="best-content">
                                        <div>
                                            <h2 className="primary-text"><AnimatedText text="Always up for new learnings" animationType="scale" /></h2>
                                            <p className="_w-69"><AnimatedText text="Those excited to build new skills, innovate, and grow alongside a rapidly developing engineering company." animationType="fade-up" />
                                            </p>
                                        </div>
                                    </div>
                                       <div className="best-content center-block">
                                        <div>
                                            <h2 className="primary-text"><AnimatedText text="Who Thrive in Teams" animationType="scale" /></h2>
                                            <p className="_w-69"><AnimatedText text="Collaboration and communication are central to how we work.If this sounds like you, Arkane Engineering could be your next big step." animationType="fade-up" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                        

                    
  

 <div className="section object-container backgrounds-gray first-story-section">
          <div className="base-container w-container">

              <div className="w-layout-grid best-content-wrapper animate-section-trigger">
                  <div className="best-content-wrap">
                      <div className="best-content">
                          <div>
                              <h2 className="primary-text"><AnimatedText text="Life at Arkane" nimationType="rotate" /></h2>
                              <p className="_w-69">
                                  <AnimatedText text="At Arkane, you’ll be part of a team that values craftsmanship and curiosity.We offer:" nimationType="fade-up" />
                              </p>
                                    <div className="info-about-beer">
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                            </div>
                                            <h4> <AnimatedText text="A clean, well-structured manufacturing environment" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                            </div>
                                            <h4> <AnimatedText text="Hands-on exposure to high-quality fabrication and engineering" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg></div>
                                            <h4> <AnimatedText text="Guidance from experienced professionals" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                            </div>
                                            <h4> <AnimatedText text="Opportunities to contribute to global-standard projects" animationType="rotate" /></h4>
                                        </div>
                                        <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                            </div>
                                            <h4> <AnimatedText text="A workplace built on respect, safety, and professionalism" animationType="rotate" /></h4>
                                        </div>
                                         {/* <div className="inf-wrapper inf-wrapper-grid-col">
                                            <div className="about">
                                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diamond-fill" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z"/>
                                    </svg>
                                            </div>
                                            <h4> <AnimatedText text="Documentation and traceability for regulated industries" animationType="rotate" /></h4>
                                        </div>
                                        */}
                                    </div>
                              <p className="_w-69">
                                  <AnimatedText text="We aim to create an environment where you can build not just a job, but a rewarding engineering career." nimationType="fade-up" />
                              </p>
                          </div>
                      </div>
                  </div>


                   <div className="img-content">
                       <div className="img-container px-600  align-end">
                          <Slider {...settings}>
                            <img src={career01} alt="Bottle of beer" className="bottle-beer" />
                              <img src={career02} alt="Bottle of beer" className="bottle-beer" />
                                <img src={career03} alt="Bottle of beer" className="bottle-beer" />
                          </Slider>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  
         
  
 <div className="section object-container object-container-career section-scroll-animation">
          <div className="base-container w-container">
              <div className="section-title-center">
                
                     <h2 className="primary-text"> Current Openings</h2>
                    <p>Join Our Team of Skilled and help us Create Innovative and Sustainable Spaces.</p>
                
              </div>
                
              <div className="layout-services">


                {Array.isArray(jobs) &&
          jobs.map(job => (
       
            <div className="services-items career-container" key={job.id}>

                <div className="service-title">

                    <span className="--h4 split-grid">Job Title: <p>{job.position}</p></span>
                    <span className="--h4 split-grid">LOCATION: <p>{job.location}</p></span>
                    <span className="--h4 split-grid">Job TYPE: <p>{job.type}</p></span>
                      <span className="--h4 split-grid">Department/Team: <p>{job.department}</p></span>
                       <span className="--h4 text-upper">Job Description: </span>
                    ‍ <p>
                       {job.requirements}
                      </p> <br/>
                    <span className="--h4 text-upper">Key Responsibilities:</span>
                       <p> {job.responsibilities
                              ?.split('-')
                              .filter(item => item.trim() !== '')
                              .map((item, index) => (
                                <li key={index}>{item.trim()}</li>
                              ))}
                              </p> <br/>     
                   
                    <span className="--h4 text-upper">Required Skills:</span>
                    <p>{job.skills
                     ?.split('-')
                              .filter(item => item.trim() !== '')
                              .map((item, index) => (
                                <li key={index}>{item.trim()}</li>
                              ))}
                    </p>
                       <button className="apply-btn primary-button full-width-mobile w-button" onClick={() => setOpen(true)}>
                            Apply Now
                        </button>

                </div>
            </div>
        
             ))}

               
               
              </div>

          </div>
      </div>

        {open && (
          <div className="modal-overlay">
      <div className="modal-content">
            <h3>Apply for Job</h3>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="form-controller">
     <div className="form-gap">
             <div className="from-gap-col">
              <input
                type="text"
                name="name"
                className="form-control contacts-input"
                placeholder="Full Name"
                required
                onChange={handleChange}
              />

              <input
                type="email"
                name="email"
                className="form-control contacts-input"
                placeholder="Email"
                required
                onChange={handleChange}
              />


              
             </div>
                <div className="from-gap-col">
                     <select
                name="jobTitle"
                className="form-control contacts-input"
                required
                onChange={handleChange}
              >
                <option value="">Select Job Title</option>
                 {Array.isArray(jobs) &&
                    jobs.map(job => (
                    <option key={job.id} value={job.position}>
                        {job.position}
                    </option>
                 ))}
              </select>

               <input
                type="tel"
                name="phone"
                className="form-control contacts-input"
                placeholder="Phone Number"
                required
                onChange={handleChange}
              />

                </div>
              
{/* 
            <div className="from-gap-col">
             

              <input
                type="file"
                name="resume"
                className="form-control contacts-input"
                accept=".pdf,.doc,.docx"
                required
                onChange={handleChange}
              />
            </div> */}
<div className="custom-file-upload">
      <label htmlFor="resume" className="upload-btn">
        Upload Resume
      </label>

      <span className="file-name">{fileName}</span>

      <input
        type="file"
        id="resume"
        name="resume"
        accept=".pdf,.doc,.docx"
        required
        onChange={handleFileChange}
      />
    </div>

              

              <div className="modal-actions">
                <button type="submit" className="primary-button full-width-mobile w-button">
                   {loading ? "Please wait..." : "Submit"}
                </button>
                <button type="button" className="primary-button full-width-mobile w-button w-button-close" onClick={() => setOpen(false)}>
                  Close
                </button>
              </div>
                </div>
</div>
       
            </form>
   
          
          </div>
        </div>
      )}
        
                 
            <ContactForm/>
                   
                
            </main>
            <Footer/>
        </section>
    )
}

export default Careers;